import { Grid, Typography } from '@mui/material';

const totalLabels = {
	'session_total': 'Total Sessions',
	'registration': 'Registrations',
	'session': 'Sessions Completed',
	'session_abandoned': 'Sessions Abandoned'
};

const gridProps = {
	size: { md: 6, xs: 12 },
	textAlign: 'center'
};

const MetricTotals = (props) => {
	const items = [];

	// eslint-disable-next-line react/prop-types
	const totals = props?.totals;

	if ( totals ) {

		for ( const k in totalLabels ) {
			if ( k in totals ) {
				items.push(
					<Grid key={k} {...gridProps}>
						<Typography variant="title-md">{totalLabels[k]}</Typography>
						<Typography variant="h3">{totals[k]}</Typography>
					</Grid>
				);
			}
		}
	}

	return <Grid container spacing={2} alignItems={'center'} {...props}>{items}</Grid>;
};

export default MetricTotals;